import * as PIXI from "pixi.js";
import Game from "./Game";
import Layers from "./layers/Layers";
import { RootEventBus, EnumRootEventBus } from "./managers/RootEventBus";
import getAngleBetweenPoints from "./utils/getAngleBtwPoints";
import { Coord } from "./types/Interface";


export default class UIComponent extends PIXI.Container {
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();
  private RootEventBus = RootEventBus;
  private RedPointTag: string;
  private circleCoord: Coord = { x: 100, y: 100 };
  private lastUnixTime = 0;

  constructor() {
    super();

    this.addBg();
    this.addToLayer();

    this.on("mousemove", e => this.handleMousemove(e));
    this.on("touchmove", e => this.handleMousemove(e));
    this.on("mouseup", () => this.handleMouseup());
    this.on("touchend", () => this.handleMouseup());
    this.on("mouseupoutside", () => this.handleMouseup());
    this.on("touchendoutside", () => this.handleMouseup());

    this.RootEventBus.on(EnumRootEventBus.setRedPointTag, PointTag => this.setRedPointTag(PointTag))
    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => this.interactive = true);
    this.RootEventBus.on(EnumRootEventBus.getCircleCoord, (coord: Coord) => this.circleCoord = coord);
  }

  private addToLayer = () => this.Layers.UI.addChild(this);
  private handleMouseup = () => this.setRedPointTag("")
  private setRedPointTag = (PointTag: string) => this.RedPointTag = PointTag;
  private addBg() {
    const texture = new PIXI.Texture(PIXI.Texture.EMPTY);
    const sprite = new PIXI.Sprite(texture);

    const dim = this.Game.getDim();
    sprite.width = dim.WIDTH;
    sprite.height = dim.HEIGHT;
    sprite.x = 0;
    sprite.y = 0
    this.addChild(sprite);
  }
  private handleMousemove(e: PIXI.FederatedPointerEvent) {
    const UnixTime = Date.now()
    if (this.RedPointTag == "" || this.RedPointTag == undefined || UnixTime < this.lastUnixTime + 10) {
      return
    }
    this.lastUnixTime = UnixTime;
    let radian = getAngleBetweenPoints(this.circleCoord, e.global);
    this.RootEventBus.emit(EnumRootEventBus.setRedPointCoord, [{ pTag: this.RedPointTag, radian }]);
  }
}